/** Время по умолчанию для срока заявки, если указана только дата */
export const DEFAULT_DATETIME_LOCAL_TIME = '21:00';

const DATE_ONLY = /^(\d{4}-\d{2}-\d{2})$/;
const TIME_ONLY = /^(\d{2}):(\d{2})$/;

const pad2 = (n) => String(n).padStart(2, '0');

/** Локальная календарная дата → YYYY-MM-DD для input[type=date] min */
export function getLocalDateInputValue(date = new Date()) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

/** ISO или datetime-local → значение для input[type=date] */
export function toDateInputValue(value) {
  if (value == null || value === '') return '';
  const trimmed = String(value).trim();
  const dateOnly = trimmed.match(DATE_ONLY);
  if (dateOnly) return dateOnly[1];

  const withTime = trimmed.match(/^(\d{4}-\d{2}-\d{2})T/);
  if (withTime) return withTime[1];

  const d = new Date(trimmed);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

/** ISO или datetime-local → значение для input[type=time] */
export function toTimeInputValue(value, defaultTime = DEFAULT_DATETIME_LOCAL_TIME) {
  if (value == null || value === '') return defaultTime;
  const trimmed = String(value).trim();
  const fromLocal = trimmed.match(/T(\d{2}):(\d{2})/);
  if (fromLocal) return `${fromLocal[1]}:${fromLocal[2]}`;

  const timeOnly = trimmed.match(TIME_ONLY);
  if (timeOnly) return trimmed;

  const d = new Date(trimmed);
  if (Number.isNaN(d.getTime())) return defaultTime;
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

/** input[type=date] + input[type=time] → ISO для API */
export function combineDateAndTimeToIso(
  dateStr,
  timeStr = DEFAULT_DATETIME_LOCAL_TIME,
  defaultTime = DEFAULT_DATETIME_LOCAL_TIME,
) {
  const date = toDateInputValue(dateStr);
  if (!date) return null;

  const time = (timeStr || '').trim() || defaultTime;
  const match = time.match(TIME_ONLY);
  if (!match) return null;

  const d = new Date(`${date}T${match[1]}:${match[2]}`);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

/** true, если срок выполнения раньше текущего момента (даты создания заявки) */
export function isDeadlineBeforeNow(dateStr, timeStr, now = new Date()) {
  const iso = combineDateAndTimeToIso(dateStr, timeStr);
  if (!iso) return false;
  return new Date(iso).getTime() < now.getTime();
}
